<template>
  <div class="modal" @click="onBgTap" @touchmove="stopMove">
    <div class="mask" @click.stop="onBgTap" @touchmove.stop="stopMove"></div>
    <div class="main" @click.stop="onMainTap" :style="mainStyle">
      <div class="title" v-if="title">{{title}}</div>
      <div class="content"><slot></slot></div>
      <div class="actions" v-if="showAction" :style="actionStyle">
        <a
          class="btn cancel"
          href="tel:400-004-0686"
          v-if="showCancel && hasCancelRef"
          :style="{color: cancelColor}"
          @click="cancel"
        >
          {{cancelText}}
          <slot name="cancel-text"></slot>
        </a>
        <div
          class="btn cancel"
          v-else-if="showCancel"
          :style="{color: cancelColor}"
          @click="cancel"
        >
          {{cancelText}}
          <slot name="cancel-text"></slot>
        </div>
        <div
          class="btn confirm"
          :class="showCancel ? ' f-bdl' : ' f-full'"
          :style="{color: confirmColor}"
          @click="confirm"
        >
          {{confirmText}}
          <slot name="confirm-text"></slot>
        </div>
      </div>
      <img
        class="close_btn"
        src="../assets/img/components/modal/gray@3x.png"
        @click="cancel"
        v-if="closeBtn"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    showAction: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    cancelColor: {
      type: String,
      default: '#212732',
    },
    confirmText: {
      type: String,
      default: '确定',
    },
    confirmColor: {
      type: String,
      default: '#377fee',
    },
    bgCancel: {
      type: Boolean,
      default: true,
    },
    closeBtn: {
      type: Boolean,
      default: false,
    },
    actionStyle: {
      type: Object,
      default: () => ({}),
    },
    mainStyle: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    /**
     * 取消
     */
    cancel() {
      this.$emit('cancel');
    },
    /**
     * 确定
     */
    confirm() {
      this.$emit('confirm');
    },
    /**
     * 点击背景
     */
    onBgTap() {
      if (this.bgCancel) {
        this.cancel();
      }
    },
    /**
     * 点击主框体
     */
    onMainTap() {},
    /**
     * 阻止滚动
     */
    stopMove(e) {
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .5);
}

.modal .main {
  position: relative;
  width: 14rem;
  border-radius: .2rem;
  background-color: #ffffff;
  padding-top: 1.25rem;
}

.modal .title {
  margin-bottom: .75rem;
  text-align: center;
  color: #212732;
  font-weight: bold;
  font-size: .9rem;
}

.modal .content {
  padding: 0 1rem .75rem;
  font-size: .75rem;
  color: #212732;
  text-align: center;
}

.modal .actions {
  border-top: 1px solid #e5e5e5;
  display: flex;
}

.modal .actions .btn {
  width: 50%;
  height: 2.5rem;
  line-height: 2.5rem;
  border: 0;
  padding: 0;
  margin: 0;
  background-color: transparent;
  font-size: .9rem;
  color: #212732;
  box-sizing: border-box;
  border-radius: 0;
  text-align: center;
  position: relative;
}

.modal .actions .btn.f-full {
  width: 100%;
}

.modal .actions .btn.f-bdl {
  border-left: 1px solid #e5e5e5;
}

.modal .actions .btn:after {
  border: 0;
}

.modal .close_btn {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  width: 2rem;
  height: 2rem;
}
</style>
